/* Baron of HAVANA spotlight carousel. Small, self-contained, no libraries.

   The center slide is large and lit, its neighbors sit smaller and dimmed on each side, and the loop is infinite.
   Slides are positioned with data-pos (-2, -1, 0, 1, 2); the CSS in sections/boh-spotlight.liquid does the moving.
   Works with arrow buttons, the left and right arrow keys, swipe, and (optionally) autoplay that pauses on hover
   and focus and has a visible pause button. Autoplay never runs when the visitor prefers reduced motion. */
(function () {
  "use strict";

  var reduced = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : { matches: false };

  function init(root) {
    if (!root || root.getAttribute("data-boh-ready")) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-boh-slide]"));
    var n = slides.length;
    if (n < 1) return;
    root.setAttribute("data-boh-ready", "1");

    var stage = root.querySelector("[data-boh-stage]");
    var fill = root.querySelector("[data-boh-fill]");
    var prevBtn = root.querySelector("[data-boh-prev]");
    var nextBtn = root.querySelector("[data-boh-next]");
    var live = root.querySelector("[data-boh-live]");
    var pauseBtn = root.querySelector("[data-boh-pause]");
    var cur = 0;
    var timer = null;
    var manualPause = false;
    var hoverPause = false;
    var wantAutoplay = root.getAttribute("data-autoplay") === "true" && !reduced.matches;
    var seconds = Math.max(3, parseInt(root.getAttribute("data-seconds"), 10) || 6);

    /* Signed distance from the current slide, going the short way around the loop. */
    function dist(i) {
      var d = (((i - cur) % n) + n) % n;
      if (d > n / 2) d -= n;
      return d;
    }

    function keyFor(d, old) {
      if (Math.abs(d) <= 1) return String(d);
      /* Hidden slides wait on the side they left from, so they never fly across the middle. */
      if (old === "-1" || old === "-2") return "-2";
      if (old === "1" || old === "2") return "2";
      return d < 0 ? "-2" : "2";
    }

    function render(first) {
      slides.forEach(function (s, i) {
        var d = dist(i);
        var old = s.getAttribute("data-pos");
        var key = keyFor(d, old);
        var wraps = !first && old !== null && ((old === "-1" && key === "1") || (old === "1" && key === "-1"));
        var hiddenToHidden = !first && old !== null && (old === "2" || old === "-2") && (key === "2" || key === "-2");
        if (wraps || hiddenToHidden) {
          /* Reposition without flying across the carousel: fade the slide in at its new place. */
          s.style.transition = "none";
          s.style.opacity = "0";
          s.setAttribute("data-pos", key);
          void s.offsetWidth;
          s.style.transition = "";
          s.style.opacity = "";
        } else {
          s.setAttribute("data-pos", key);
        }
        var active = d === 0;
        if (active) { s.removeAttribute("inert"); s.removeAttribute("aria-hidden"); }
        else { s.setAttribute("inert", ""); s.setAttribute("aria-hidden", "true"); }
      });
      if (fill) fill.style.transform = "translateX(" + cur * 100 + "%)";
    }

    function announce() {
      if (live) live.textContent = "Slide " + (cur + 1) + " of " + n;
    }

    function goTo(i, byUser) {
      cur = ((i % n) + n) % n;
      render(false);
      if (byUser) { announce(); if (wantAutoplay && !manualPause) restart(); }
    }
    function next(byUser) { goTo(cur + 1, byUser); }
    function prev(byUser) { goTo(cur - 1, byUser); }

    /* ---- autoplay ---- */
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (!wantAutoplay || manualPause || hoverPause || document.hidden) return;
      timer = setInterval(function () { next(false); }, seconds * 1000);
    }
    function restart() { stop(); start(); }
    function setPauseLabel() {
      if (!pauseBtn) return;
      pauseBtn.setAttribute("aria-pressed", manualPause ? "true" : "false");
      pauseBtn.setAttribute("aria-label", manualPause ? "Play the slideshow" : "Pause the slideshow");
      pauseBtn.setAttribute("data-state", manualPause ? "paused" : "playing");
    }

    if (n < 2) {
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
      if (pauseBtn) pauseBtn.hidden = true;
    } else {
      if (prevBtn) prevBtn.addEventListener("click", function () { prev(true); });
      if (nextBtn) nextBtn.addEventListener("click", function () { next(true); });
    }

    if (pauseBtn) {
      if (!wantAutoplay || n < 2) pauseBtn.hidden = true;
      else {
        pauseBtn.hidden = false;
        setPauseLabel();
        pauseBtn.addEventListener("click", function () { manualPause = !manualPause; setPauseLabel(); manualPause ? stop() : start(); });
      }
    }
    if (wantAutoplay && n > 1) {
      root.addEventListener("mouseenter", function () { hoverPause = true; stop(); });
      root.addEventListener("mouseleave", function () { hoverPause = false; start(); });
      root.addEventListener("focusin", function () { hoverPause = true; stop(); });
      root.addEventListener("focusout", function () { hoverPause = false; start(); });
      document.addEventListener("visibilitychange", function () { document.hidden ? stop() : start(); });
    }

    /* ---- keyboard: left and right arrows while focus is inside the carousel ---- */
    root.addEventListener("keydown", function (e) {
      if (n < 2) return;
      var t = e.target;
      if (t && /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName)) return;
      if (e.key === "ArrowRight") { e.preventDefault(); next(true); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); prev(true); }
    });

    /* ---- clicking a neighbor brings it to the center ---- */
    slides.forEach(function (s, i) {
      s.addEventListener("click", function (e) {
        if (s.getAttribute("data-pos") === "0" || dragged) return;
        e.preventDefault();
        goTo(i, true);
      });
    });

    /* ---- swipe ---- */
    var sx = 0, sy = 0, dragging = false, dragged = false, pid = null;
    if (stage && n > 1) {
      stage.addEventListener("pointerdown", function (e) {
        if (e.pointerType === "mouse" && e.button !== 0) return;
        sx = e.clientX; sy = e.clientY; dragging = true; dragged = false; pid = e.pointerId;
      });
      stage.addEventListener("pointermove", function (e) {
        if (!dragging || e.pointerId !== pid) return;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (!dragged && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) dragged = true;
      });
      var end = function (e) {
        if (!dragging || (e && e.pointerId !== pid)) return;
        dragging = false;
        var dx = (e ? e.clientX : sx) - sx;
        if (dragged && Math.abs(dx) > 40) { dx < 0 ? next(true) : prev(true); }
        /* Let the click that follows a swipe pass, then allow clicks again. */
        setTimeout(function () { dragged = false; }, 60);
      };
      stage.addEventListener("pointerup", end);
      stage.addEventListener("pointercancel", end);
      stage.addEventListener("click", function (e) { if (dragged) { e.preventDefault(); e.stopPropagation(); } }, true);
    }

    /* ---- theme editor: show the slide being edited ---- */
    root.addEventListener("shopify:block:select", function (e) {
      var id = e.detail && e.detail.blockId;
      slides.forEach(function (s, i) { if (s.getAttribute("data-block-id") === id) { stop(); goTo(i, false); } });
    });

    render(true);
    start();
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll("[data-boh-spotlight]"), init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initAll(); });
  else initAll();
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();
